module.exports = __webpack_public_path__ + "img/Blue_shield.b402c8a0.png";